export default __webpack_public_path__ + "static/media/drag-and-drop.4d295278.svg";